// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Draggable workflow nodes: hand pointer instead of the default arrow. */
.react-flow__node.draggable {
  cursor: pointer;
}

.react-flow__node.draggable.dragging {
  cursor: grabbing;
}

.nav-tabs {
  font-size: 12px;
}

.text-updater-node {
  height: 50px;
  border: 1px solid #eee;
  padding: 5px;
  border-radius: 5px;
  background: white;
}

.text-updater-node label {
  display: block;
  color: #777;
  font-size: 12px;
}

.react-flow__handle-top {
  top: -20px !important;
  width: 20px;
  height: 20px;
  background: #555;
  border-radius: 50%;
}

.react-flow__handle-left {
  left: -20px !important;
  width: 20px;
  height: 20px;
  background: #555;
  border-radius: 50%;
}

.react-flow__handle-right {
  right: -20px !important;
  width: 20px;
  height: 20px;
  background: #555;
  border-radius: 50%;
}

/* Notebook view: a cell's dots in the connections bar keep the right-handle
   rules above; an input dot carries the number its chips use. */
.curio-notebook-dot-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  pointer-events: none;
  user-select: none;
}

/* Notebook view: a cell shows its input and its output together, the input
   over the output, each at its own height. The output pane, which Bootstrap
   hides (display) and fades out (opacity) while another tab is active, stays
   visible below the active input tab. */
.tab-content.curio-notebook-split {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tab-content.curio-notebook-split > .tab-pane.active {
  flex: 0 0 auto;
}

.tab-content.curio-notebook-split > .tab-pane.curio-notebook-output {
  display: block !important;
  opacity: 1 !important;
  flex: 0 0 auto;
}

/* A node's tools (the editor's tabs, Save output, the gear, info, pin and, on
   the canvas, minimize and delete) show while the pointer is
   over the node, or the node is selected or holds the focus, as a Jupyter
   cell's toolbar does. Play, the title, the kind and the run status always
   show. The same on the canvas and in a notebook cell. */
.curio-node-card .curio-node-tools {
  opacity: 0;
  transition: opacity 120ms ease;
}

.curio-node-card:hover .curio-node-tools,
.curio-node-card:focus-within .curio-node-tools,
.curio-node-card.is-selected .curio-node-tools {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .curio-node-card .curio-node-tools {
    transition: none;
  }
}

/* The tabs among those tools: icons in a row, the active one darker, no pill
   or bar. */
.curio-node-tabs .nav.flex-column {
  flex-direction: row !important;
  flex-wrap: nowrap;
}

/* Widths \`auto\`: Bootstrap's \`.row > *\` sets \`width: 100%\`, which collapses in
   a header that is as wide as its content and piles the icons up. */
.curio-node-tabs .row {
  --bs-gutter-x: 0;
  width: auto;
  margin: 0;
  flex-wrap: nowrap;
  font-size: 12px;
}

.curio-node-tabs .row > .col {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  padding: 0;
}

/* \`!important\` against NodeEditor.css's own, which marks an active pill dark. */
.curio-node-tabs .nav-pills .nav-link {
  padding: 2px 6px;
  background: none !important;
  color: #a3a3a3 !important;
}

.curio-node-tabs .nav-pills .nav-link.active,
.curio-node-tabs .nav-pills .nav-link:hover {
  color: var(--curio-text-primary, #222) !important;
}

/* A node's code or spec sits in a light gray box, as a notebook's input does. */
.curio-node-input {
  background: #f6f7f8;
  border-radius: 6px;
}

.curio-node-input .monaco-editor {
  --vscode-editor-background: transparent;
  --vscode-editorGutter-background: transparent;
}

.handle_top_left {
  left: -20px !important;
  width: 20px;
  height: 20px;
  background: #555;
  border-radius: 50%;
  top: 10px;
}

.handle_bottom_left {
  left: -20px !important;
  width: 20px;
  height: 20px;
  background: #555;
  border-radius: 50%;
  top: 40px !important;
}

.error-traceback-scroll {
  max-height: 100%;
  overflow-y: auto;
  background: #ffebee;
  border-radius: 8px;
  padding: 16px;
  font-family: monospace;
  color: #b71c1c;
}
.my-error-node .error-traceback-scroll {
  max-height: 100%;
  overflow-y: auto;
  background: #ffebee;
  border-radius: 8px;
  padding: 16px;
  font-family: monospace;
  color: #b71c1c;
}`, "",{"version":3,"sources":["webpack://./src/components/Node.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;gEACgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;;wCAGwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;yDAIyD;AACzD;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;YACY;AACZ;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;oEACoE;AACpE;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":["/* Draggable workflow nodes: hand pointer instead of the default arrow. */\n.react-flow__node.draggable {\n  cursor: pointer;\n}\n\n.react-flow__node.draggable.dragging {\n  cursor: grabbing;\n}\n\n.nav-tabs {\n  font-size: 12px;\n}\n\n.text-updater-node {\n  height: 50px;\n  border: 1px solid #eee;\n  padding: 5px;\n  border-radius: 5px;\n  background: white;\n}\n\n.text-updater-node label {\n  display: block;\n  color: #777;\n  font-size: 12px;\n}\n\n.react-flow__handle-top {\n  top: -20px !important;\n  width: 20px;\n  height: 20px;\n  background: #555;\n  border-radius: 50%;\n}\n\n.react-flow__handle-left {\n  left: -20px !important;\n  width: 20px;\n  height: 20px;\n  background: #555;\n  border-radius: 50%;\n}\n\n.react-flow__handle-right {\n  right: -20px !important;\n  width: 20px;\n  height: 20px;\n  background: #555;\n  border-radius: 50%;\n}\n\n/* Notebook view: a cell's dots in the connections bar keep the right-handle\n   rules above; an input dot carries the number its chips use. */\n.curio-notebook-dot-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1;\n  pointer-events: none;\n  user-select: none;\n}\n\n/* Notebook view: a cell shows its input and its output together, the input\n   over the output, each at its own height. The output pane, which Bootstrap\n   hides (display) and fades out (opacity) while another tab is active, stays\n   visible below the active input tab. */\n.tab-content.curio-notebook-split {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tab-content.curio-notebook-split > .tab-pane.active {\n  flex: 0 0 auto;\n}\n\n.tab-content.curio-notebook-split > .tab-pane.curio-notebook-output {\n  display: block !important;\n  opacity: 1 !important;\n  flex: 0 0 auto;\n}\n\n/* A node's tools (the editor's tabs, Save output, the gear, info, pin and, on\n   the canvas, minimize and delete) show while the pointer is\n   over the node, or the node is selected or holds the focus, as a Jupyter\n   cell's toolbar does. Play, the title, the kind and the run status always\n   show. The same on the canvas and in a notebook cell. */\n.curio-node-card .curio-node-tools {\n  opacity: 0;\n  transition: opacity 120ms ease;\n}\n\n.curio-node-card:hover .curio-node-tools,\n.curio-node-card:focus-within .curio-node-tools,\n.curio-node-card.is-selected .curio-node-tools {\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .curio-node-card .curio-node-tools {\n    transition: none;\n  }\n}\n\n/* The tabs among those tools: icons in a row, the active one darker, no pill\n   or bar. */\n.curio-node-tabs .nav.flex-column {\n  flex-direction: row !important;\n  flex-wrap: nowrap;\n}\n\n/* Widths `auto`: Bootstrap's `.row > *` sets `width: 100%`, which collapses in\n   a header that is as wide as its content and piles the icons up. */\n.curio-node-tabs .row {\n  --bs-gutter-x: 0;\n  width: auto;\n  margin: 0;\n  flex-wrap: nowrap;\n  font-size: 12px;\n}\n\n.curio-node-tabs .row > .col {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n  padding: 0;\n}\n\n/* `!important` against NodeEditor.css's own, which marks an active pill dark. */\n.curio-node-tabs .nav-pills .nav-link {\n  padding: 2px 6px;\n  background: none !important;\n  color: #a3a3a3 !important;\n}\n\n.curio-node-tabs .nav-pills .nav-link.active,\n.curio-node-tabs .nav-pills .nav-link:hover {\n  color: var(--curio-text-primary, #222) !important;\n}\n\n/* A node's code or spec sits in a light gray box, as a notebook's input does. */\n.curio-node-input {\n  background: #f6f7f8;\n  border-radius: 6px;\n}\n\n.curio-node-input .monaco-editor {\n  --vscode-editor-background: transparent;\n  --vscode-editorGutter-background: transparent;\n}\n\n.handle_top_left {\n  left: -20px !important;\n  width: 20px;\n  height: 20px;\n  background: #555;\n  border-radius: 50%;\n  top: 10px;\n}\n\n.handle_bottom_left {\n  left: -20px !important;\n  width: 20px;\n  height: 20px;\n  background: #555;\n  border-radius: 50%;\n  top: 40px !important;\n}\n\n.error-traceback-scroll {\n  max-height: 100%;\n  overflow-y: auto;\n  background: #ffebee;\n  border-radius: 8px;\n  padding: 16px;\n  font-family: monospace;\n  color: #b71c1c;\n}\n.my-error-node .error-traceback-scroll {\n  max-height: 100%;\n  overflow-y: auto;\n  background: #ffebee;\n  border-radius: 8px;\n  padding: 16px;\n  font-family: monospace;\n  color: #b71c1c;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
